// extracted by mini-css-extract-plugin
export var card_bg = "index-module--card_bg--7a6b0";
export var card_main_container = "index-module--card_main_container--41638";
export var card_main_only_title_layout = "index-module--card_main_only_title_layout--0fbba";
export var content_container = "index-module--content_container--61094";
export var icon_container = "index-module--icon_container--96039";
export var nav_card_container = "index-module--nav_card_container--02b5b";
export var nav_card_desc = "index-module--nav_card_desc--6679c";
export var nav_card_only_title_layout = "index-module--nav_card_only_title_layout--f2cad";
export var nav_icon = "index-module--nav_icon--51208";